import type {ReactElement} from 'react'

export default function Eye(): ReactElement {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.3" clipPath="url(#clip0_246_1558)">
        <path
          d="M0.985966 7.01178C2.01997 5.32777 4.37197 2.50244 8.49997 2.50244C12.628 2.50244 14.98 5.32777 16.014 7.01178C16.3336 7.52878 16.5029 8.1246 16.5029 8.73244C16.5029 9.34028 16.3336 9.9361 16.014 10.4531C14.98 12.1371 12.628 14.9624 8.49997 14.9624C4.37197 14.9624 2.01997 12.1371 0.985966 10.4531C0.666317 9.9361 0.497002 9.34028 0.497002 8.73244C0.497002 8.1246 0.666317 7.52878 0.985966 7.01178ZM2.12263 9.75511C3.01063 11.1991 5.02063 13.6291 8.49997 13.6291C11.9793 13.6291 13.9893 11.1991 14.8773 9.75511C15.0672 9.44781 15.1678 9.09369 15.1678 8.73244C15.1678 8.37119 15.0672 8.01708 14.8773 7.70977C13.9893 6.26577 11.9793 3.83577 8.49997 3.83577C5.02063 3.83577 3.01063 6.26311 2.12263 7.70977C1.93272 8.01708 1.83213 8.37119 1.83213 8.73244C1.83213 9.09369 1.93272 9.44781 2.12263 9.75511Z"
          fill="#272727"
        />
        <path
          d="M8.49967 5.39893C9.15894 5.39893 9.80341 5.59442 10.3516 5.96069C10.8997 6.32697 11.327 6.84756 11.5793 7.45665C11.8316 8.06574 11.8976 8.73596 11.769 9.38256C11.6403 10.0292 11.3229 10.6231 10.8567 11.0893C10.3905 11.5555 9.79658 11.8729 9.14997 12.0015C8.50337 12.1302 7.83315 12.0642 7.22406 11.8119C6.61497 11.5596 6.09438 11.1323 5.72811 10.5842C5.36184 10.036 5.16634 9.39153 5.16634 8.73226C5.1674 7.84853 5.51893 7.0013 6.14382 6.37641C6.76871 5.75151 7.61594 5.39998 8.49967 5.39893ZM8.49967 10.7323C8.89524 10.7323 9.28192 10.615 9.61081 10.3952C9.93971 10.1754 10.1961 9.86308 10.3474 9.49763C10.4988 9.13217 10.5384 8.73004 10.4612 8.34208C10.3841 7.95412 10.1936 7.59775 9.91389 7.31805C9.63418 7.03834 9.27782 6.84786 8.88985 6.77069C8.50189 6.69352 8.09976 6.73312 7.73431 6.8845C7.36885 7.03588 7.0565 7.29222 6.83673 7.62112C6.61697 7.95002 6.49967 8.3367 6.49967 8.73226C6.49967 9.26269 6.71039 9.7714 7.08546 10.1465C7.46053 10.5215 7.96924 10.7323 8.49967 10.7323Z"
          fill="#272727"
        />
      </g>
      <defs>
        <clipPath id="clip0_246_1558">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="matrix(-1 0 0 1 16.5 0.732422)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
